import { IncomingDetailData, IncomingDetailInboundDialogProps, IncomingDetailInboundInventoryData, PoGoodsShelf } from '../../../types/inbound'
import { Dialog } from 'primereact/dialog'
import React, { useContext, useRef, useState, useEffect } from 'react'
import { Button } from 'primereact/button'
import { InputNumber } from 'primereact/inputnumber'
import { Dropdown } from 'primereact/dropdown'
import moment from 'moment'
import { useMountEffect } from 'primereact/hooks'
import { cloneDeep, groupBy, isEmpty, sumBy, uniq } from 'lodash'
import { CommonContext } from '../../common/context/commonContext'
import { InputText } from 'primereact/inputtext'
import { ScrollPanel } from 'primereact/scrollpanel'
import { classNames } from 'primereact/utils'
import usePreventRefresh from '../../../utils/usePreventRefresh'
import useBlockBackNavigation from '../../../utils/useBlockBackNavigation'
import { useLocation } from 'react-router-dom'
import { IoSearch } from 'react-icons/io5'
import { tokens } from 'locales/tokens'
import { useTranslation } from 'react-i18next'

// 입고 적치
const goodsOrdUnitTypes = [
    {
        codeId: 'EA',
        codeNm: 'EA',
        displayNm: 'EA',
        fltrCd: undefined,
        chainCode: '',
        codeGroupId: 'GD_ORD_TYP',
    },
    {
        codeId: 'PK',
        codeNm: 'PK',
        displayNm: 'PK',
        fltrCd: undefined,
        chainCode: '',
        codeGroupId: 'GD_ORD_TYP',
    },
    {
        codeId: 'BOX',
        codeNm: 'BOX',
        displayNm: 'BOX',
        fltrCd: undefined,
        chainCode: '',
        codeGroupId: 'GD_ORD_TYP',
    },
    {
        codeId: 'KG',
        codeNm: 'KG',
        displayNm: 'KG',
        fltrCd: undefined,
        chainCode: '',
        codeGroupId: 'GD_ORD_TYP',
    },
]

const IncomingDetailArrivalDialog = (props: IncomingDetailInboundDialogProps) => {
    const { $toast, $http, $alert } = useContext(CommonContext)
    const { t } = useTranslation()
    const barcodeRef = useRef(null)
    const [inData, setInData] = useState<IncomingDetailData>()
    const [originShelfs, setOriginShelfs] = useState<PoGoodsShelf[]>([])
    const [inventories, setInventories] = useState<IncomingDetailInboundInventoryData[]>([])
    const [activeInventory, setActiveInventory] = useState<IncomingDetailInboundInventoryData>()
    const [shlfYn, setShlfYn] = useState<string>('')
    const [barcode, setBarcode] = useState<string>('')
    const [confirmDisabled, setConfirmDisabled] = useState<boolean>(true)
    const [filterTypes, setFilterTypes] = useState<any>([])
    const [shelfDays, setShelfDays] = useState<any>([])
    const [lots, setLots] = useState<any>([])
    const location = useLocation()
    const handleButtonClick = () => {
        const event = new KeyboardEvent('keydown', { key: 'Enter' })
        document.dispatchEvent(event)
    }

    usePreventRefresh()
    useBlockBackNavigation()

    useMountEffect(() => {
        if (!props.data) return
        console.log('useMountEffect-Arrival', props.data)
        setShlfYn(props.data.shlfYn)
        setInData(props.data)
        setOriginShelfs(props.data.checkShelfs)
        if (isEmpty(props.data.checkShelfs)) {
            $toast({ title: t(tokens.common.fail), text: t(tokens.inbound.no_receipt_data), icon: 'warm' })
            return
        }
        setShelfDays(
            uniq(
                props.data.checkShelfs
                    .map(({ shlfYmd }) => shlfYmd)
                    .map((data) => {
                        return {
                            codeId: data,
                            codeNm: data ? moment(data).format('YY-MM-DD') : data,
                        }
                    }),
            ),
        )
        setLots(
            uniq(
                props.data.checkShelfs
                    .map(({ lotNo }) => lotNo)
                    .map((data) => {
                        return {
                            codeId: data,
                            codeNm: data,
                        }
                    }),
            ),
        )

        setFilterTypes(
            goodsOrdUnitTypes.filter((unitType) => {
                switch (props.data.gdslsUnitCd) {
                    case 'PK':
                        return unitType.codeId === 'PK' || unitType.codeId === 'BOX'
                    case 'EA':
                        return unitType.codeId === 'EA' || unitType.codeId === 'BOX'
                    case 'BOX':
                        return unitType.codeId === 'BOX'
                    case 'KG':
                        return unitType.codeId === 'KG' || unitType.codeId === 'BOX'
                    default:
                        return null
                }
            }),
        )
    })

    const onChangeData = (invn: IncomingDetailInboundInventoryData, type: 'invnQty' | 'invnUnitCd' | 'invnShelfYmd' | 'invnLotNo', value: any) => {
        const gdslsUnitCd = props.data.gdslsUnitCd
        const boxInbQty = props.data.boxQty
        switch (type) {
            case 'invnQty':
                invn[type] = value as number
                // 판매단위 수량 맞춰서 적용
                if (invn.invnUnitCd === gdslsUnitCd) {
                    invn.gdslsQty = value
                } else {
                    invn.gdslsQty = value * boxInbQty
                }
                break
            case 'invnUnitCd':
                invn[type] = value as string
                // 판매단위 수량 맞춰서 적용
                if (invn.invnUnitCd === gdslsUnitCd) {
                    if (invn.invnQty === null) {
                        invn.gdslsQty = 0
                    } else {
                        invn.gdslsQty = invn.invnQty
                    }
                } else {
                    if (invn.invnQty === null) {
                        invn.gdslsQty = 0
                    } else {
                        invn.gdslsQty = invn.invnQty * boxInbQty
                    }
                }
                break
            case 'invnShelfYmd':
                // invn[type] = value as Date
                invn[type] = value as string // 콤보선택
                const shelfIndex = shelfDays.findIndex((day: any) => day.codeId === value)
                if (shelfIndex !== -1 && lots[shelfIndex]) {
                    invn.invnLotNo = lots[shelfIndex].codeId
                }
                break
            case 'invnLotNo':
                invn[type] = value as string
                break
        }

        inventories[inventories.findIndex((v) => v.lctSeq === invn.lctSeq && v.seq === invn.seq)] = invn
        const resultInvns = cloneDeep(inventories)
        setInventories(cloneDeep(inventories))
        checkConfirm(resultInvns)
    }

    const onClickSave = async () => {
        if (shlfYn !== 'Y') {
            inventories.forEach((invn) => (invn.invnShelfYmd = '99991231'))
        }

        const result = await $http().post('/inbound/keep', {
            inbId: props.data.inbId,
            goodsId: props.data.goodsId,
            goodsNm: props.data.goodsNm,
            prSeq: props.data.prSeq,
            gdslsUnitCd: props.data.gdslsUnitCd,
            inventories,
        })

        if (result) {
            $toast({ title: t(tokens.common.success), text: t(tokens.inbound.receipt_processing_completed), icon: 'success' })
            props.onHide(true)
        }
    }

    const onClickLocationSearch = async () => {
        const pBarcode = barcode
        setBarcode('') //reset

        const result = await $http().get('/inbound/location-info', { params: { barcode: pBarcode } })
        if (!result) return
        const location = result.location
        if (location === null) {
            $alert({
                icon: 'error',
                title: t(tokens.inventory.location_barcode_error),
                text: t(tokens.inventory.location_barcode_information_is_incorrect),
            })
            return
        }

        if (location.goodsTmprCd !== inData?.goodsTmprCd) {
            // 이미 발주정보 기준 품온 확인
            $alert({
                icon: 'info',
                title: t(tokens.inventory.check_location_temperature),
                text: `${t(tokens.common.order_form_temperature)} [` + inData?.goodsTmprNm + ']' + `${t(tokens.inventory.is_not_the_location_of)}`,
            })
            return
        }
        if (location.lctTypCd !== 'KP' && location.lctTypCd !== 'PK') {
            $alert({
                icon: 'info',
                title: t(tokens.inventory.check_location_usage),
                text: t(tokens.inventory.please_process_product_stacking_at_the_picking_storage_location) + '(' + location.lctTypNm + ')',
            })
            return
        }

        let invnQty = null
        let invnUnitCd = ''
        let invnShelfYmd = ''
        let invnLotNo = undefined
        let gdslsQty = 0;
        // box 단위 수량 계산시에 0이 곱해지면 안되기 때문에 1로 계산
        let boxQty = (inData?.boxQty && inData.boxQty > 0) ? inData.boxQty : 1;

        if(inventories.length === 0 &&
            inData?.waitShelfs?.length !== undefined && inData?.waitShelfs?.length > 0 &&
            inData?.checkShelfs?.length !== undefined && inData?.checkShelfs?.length > 0 &&
            inData?.waitShelfs[0].goodsQty === inData?.checkShelfs[0].goodsQty) {

            invnQty =  inData?.checkShelfs[0].goodsQty ?? null;
            invnUnitCd = inData?.checkShelfs[0].cnfrUnitCd ? inData?.checkShelfs[0].cnfrUnitCd : '';
            invnShelfYmd = inData?.checkShelfs[0].shlfYmd ?? '';
            invnLotNo = inData?.checkShelfs[0].lotNo ?? undefined;
            gdslsQty = (invnUnitCd === inData.gdslsUnitCd) ? (invnQty ?? 0) : (invnQty ?? 0) * boxQty;

        }

        const addInvn = {
            lctSeq: barcode,
            lctNo: location.lctNo,
            sectorNm: location.sectorNm,
            seq: inventories.length + 1,
            invnQty: invnQty,
            invnUnitCd: invnUnitCd,
            invnShelfYmd: invnShelfYmd,
            invnLotNo: invnLotNo,
            gdslsQty: gdslsQty,
            locationAlias: location.locationAlias,
        }
        const resultInvns = [addInvn, ...inventories]

        setActiveInventory(addInvn)
        setInventories(resultInvns)
        checkConfirm(resultInvns)
    }

    const onKeyDownSearch = async (e: React.KeyboardEvent<HTMLDivElement>) => {
        if (e.key === 'Enter' || e.key === 'Tab') {
            await onClickLocationSearch();
        }
    }

    const onClickDelete = () => {
        if (activeInventory) {
            const resultInvns = inventories.filter(({ seq }) => seq !== activeInventory.seq)

            if (!isEmpty(resultInvns)) {
                setActiveInventory(resultInvns[0])
            }

            setInventories(resultInvns)
            checkConfirm(resultInvns)
        }
    }

    const checkConfirm = (inventories: IncomingDetailInboundInventoryData[]) => {
        if (!inventories) {
            setConfirmDisabled(true)
            return
        }

        const notInput =
            shlfYn === 'Y'
                ? inventories.some(({ invnQty, invnUnitCd, invnShelfYmd }) => !invnQty || !invnUnitCd || !invnShelfYmd )
                : inventories.some(({ invnQty, invnUnitCd }) => !invnQty || !invnUnitCd)
        // console.log('notInput', notInput)
        if (notInput) {
            setConfirmDisabled(true)
            return
        }

        if (shlfYn === 'Y') {
            const originShlfYmds = groupBy(originShelfs, function (v) {
                return v.shlfYmd
            })
            const invnShlfYmds = groupBy(inventories, function (v) {
                return v.invnShelfYmd
            })

            for (const key in originShlfYmds) {
                const originGdslsQty = sumBy(originShlfYmds[key], 'gdslsQty')
                const inventoryGdslsQty = sumBy(invnShlfYmds[key], 'gdslsQty')

                if (originGdslsQty !== inventoryGdslsQty) {
                    setConfirmDisabled(true)
                    return
                }
            } // 체크 전부 통과하면 수량 같음
        } else {
            const originGdslsQty = sumBy(originShelfs, 'gdslsQty')
            const inventoryGdslsQty = sumBy(inventories, 'gdslsQty')

            if (originGdslsQty !== inventoryGdslsQty) {
                setConfirmDisabled(true)
                return
            } // 체크 전부 통과하면 수량 같음
        }

        setConfirmDisabled(false)
    }

    const onClickClose = async () => {
        const isConfirm = await $alert({
            icon: 'warn',
            title: t(tokens.common.close),
            text: t(tokens.common.if_you_leave_the_page_your_work_will_not_be_saved),
            isConfirm: true,
        })
        if (isConfirm) {
            props.onHide(false)
        }
    }

    // 뒤로가기 막기
    useEffect(() => {
        const handlePopState = (event: PopStateEvent) => {
            window.history.pushState(null, '', window.location.href)
        }
        if (location.pathname === '/') {
            window.history.pushState(null, '', window.location.href)
            window.addEventListener('popstate', handlePopState)
        }
        return () => {
            window.removeEventListener('popstate', handlePopState)
        }
    }, [location.pathname])

    const footer = () => {
        return (
            <div className="grid ">
                <div className="col-12 flex mt-4 p-0">
                    <Button className="w-full p-button-danger" label={t(tokens.common.remove_item)} size="large" onClick={onClickDelete} />
                </div>
                <div className="col-6 flex pl-0 mt-1">
                    <Button className="w-full p-button-secondary" label={t(tokens.common.close)} size="large" onClick={onClickClose} />
                </div>
                <div className="col-6 flex pr-0 mt-1">
                    <Button
                        className="w-full p-button-success"
                        label={t(tokens.inbound.complete)}
                        size="large"
                        onClick={onClickSave}
                        disabled={confirmDisabled}
                    />
                </div>
            </div>
        )
    }
    return (
        <>
            <Dialog
                header={t(tokens.inbound.inbound_stack)}
                visible={props.visible}
                onHide={() => props.onHide && props.onHide(false)}
                closable={false}
                contentClassName="pb-0"
                footer={footer}
                style={{ overscrollBehavior: 'contain', overflow: 'hidden' }}
            >
                {props.data && (
                    <div className="grid">
                        <div className="col-12 flex rdms-text-primary font-bold text-xl mt-2">{t(tokens.common.product_name)} | {t(tokens.common.product_barcode)}</div>
                        <div className="col-12 flex text-lg mt-0 text-2xl pt-0">{props.data.goodsNm} | {props.data.sysCd}</div>
                        <div className="col-12 flex text-lg mt-0 pt-0 px-0 mt-2" style={{ position: 'relative', alignItems: 'center' }}>
                            <InputText
                                ref={barcodeRef}
                                value={barcode}
                                className="w-full"
                                onKeyDown={(e) => onKeyDownSearch(e)}
                                onChange={(e) => setBarcode(e.currentTarget.value)}
                                placeholder={t(tokens.inventory.please_scan_the_location_label_barcode)}
                            />
                            <label onClick={onClickLocationSearch} style={{ position: 'absolute', margin: 'auto 0', right: '10px' }}>
                                <IoSearch size="22" />
                            </label>
                        </div>

                        <div className="col-12 flex mt-0 pt-0 px-0 mt-2">
                            <ScrollPanel style={{ height: '350px', overscrollBehavior: 'contain', overflow: 'hidden' }}>
                                <div className="grid">
                                    {inventories &&
                                        inventories.map((invn) => (
                                            <React.Fragment key={invn.seq}>
                                                <div
                                                    className={classNames({
                                                        'border-bottom-1': true,
                                                        'border-color-blue': true,
                                                        'p-2': true,
                                                        'bg-color-blue': invn.seq === activeInventory?.seq,
                                                        'text-white': invn.seq === activeInventory?.seq,
                                                        'rdms-text-primary': invn.seq !== activeInventory?.seq,
                                                    })}
                                                    onClick={() => setActiveInventory(invn)}
                                                >
                                                    <div className="col-12 flex mt-2 py-0">
                                                        <div className="flex font-bold text-xl">{t(tokens.inventory.location_address)}</div>
                                                        <div className="flex ml-4 align-self-center font-bold">
                                                            {invn.sectorNm + invn.lctNo.slice(-7).slice(0, -1) + '0' + invn.lctNo.slice(-7).slice(-1) + ' / ' + invn.locationAlias}
                                                        </div>
                                                    </div>
                                                    <div className="col-12 flex font-bold text-xl mt-2 grid py-0">
                                                        <div className="col-6">{t(tokens.inbound.placement_qty)}</div>
                                                        <div className="col-6">{t(tokens.common.unit)}</div>
                                                    </div>
                                                    <div className="col-12 flex font-bold text-xl mt-2 grid py-0">
                                                        {shlfYn === 'Y' ? (
                                                            <>
                                                                <div className="col-6">{t(tokens.common.lot_no)}</div>
                                                                <div className="col-6">{t(tokens.common.expiration_date)}</div>
                                                            </>
                                                            ) : null}
                                                    </div>

                                                        {shlfYn === 'Y' ? (
                                                            <>
                                                                <div className="col-12 flex text-lg mt-0 py-0 grid">
                                                                    <>
                                                                        <div className="col-6 py-0 mt-1">
                                                                        <InputNumber
                                                                                inputClassName="flex w-full p-inputtext-lg"
                                                                                value={invn.invnQty}
                                                                                onChange={(e) => onChangeData(invn, 'invnQty', e.value)}
                                                                                onBlur={() => setActiveInventory(invn)}
                                                                                maxFractionDigits={invn.invnUnitCd === 'KG' ? 1 : 0}/>
                                                                        </div>
                                                                        <div className="col-6 py-0 mt-1">
                                                                        <Dropdown
                                                                                value={invn.invnUnitCd}
                                                                                className="flex w-full p-inputtext-lg text-lg"
                                                                                panelClassName="p-inputtext-lg"
                                                                                options={filterTypes}
                                                                                optionValue="codeId"
                                                                                optionLabel="codeNm"
                                                                                onChange={(e) => onChangeData(invn, 'invnUnitCd', e.value)}
                                                                                onSelectCapture={() => setActiveInventory(invn)}/>
                                                                        </div>
                                                                    </>
                                                                </div>
                                                                <div className="col-12 flex text-lg mt-0 py-0 grid">
                                                                    <>
                                                                        <div className="col-6 py-0 mt-1">
                                                                            <Dropdown
                                                                                value={invn.invnLotNo}
                                                                                className="flex w-full p-inputtext-lg text-lg"
                                                                                panelClassName="p-inputtext-lg"
                                                                                disabled={true}
                                                                                options={lots}
                                                                                optionValue="codeId"
                                                                                optionLabel="codeNm"
                                                                                onChange={(e) => onChangeData(invn, 'invnLotNo', e.value)}
                                                                                onSelectCapture={() => setActiveInventory(invn)}/>
                                                                        </div>
                                                                        <div className="col-6 py-0 mt-1">
                                                                            <Dropdown
                                                                                value={invn.invnShelfYmd}
                                                                                className="flex w-full p-inputtext-lg text-lg"
                                                                                panelClassName="p-inputtext-lg"
                                                                                options={shelfDays}
                                                                                optionValue="codeId"
                                                                                optionLabel="codeNm"
                                                                                onChange={(e) => onChangeData(invn, 'invnShelfYmd', e.value)}
                                                                                onSelectCapture={() => setActiveInventory(invn)}/>
                                                                        </div>
                                                                    </>
                                                                </div>
                                                            </>
                                                        ) : (
                                                            <div className="col-12 flex text-lg mt-0 py-0 grid">
                                                                <>
                                                                    <div className="col-6 py-0 mt-1">
                                                                        <InputNumber
                                                                            inputClassName="flex w-full p-inputtext-lg"
                                                                            value={invn.invnQty}
                                                                            onChange={(e) => onChangeData(invn, 'invnQty', e.value)}
                                                                            onBlur={() => setActiveInventory(invn)}
                                                                        />
                                                                    </div>
                                                                    <div className="col-6 py-0 mt-1">
                                                                        <Dropdown
                                                                            value={invn.invnUnitCd}
                                                                            className="flex w-full p-inputtext-lg text-sm"
                                                                            panelClassName="p-inputtext-sm"
                                                                            options={filterTypes}
                                                                            optionValue="codeId"
                                                                            optionLabel="codeNm"
                                                                            onChange={(e) => onChangeData(invn, 'invnUnitCd', e.value)}
                                                                            onSelectCapture={() => setActiveInventory(invn)}
                                                                        />
                                                                    </div>
                                                                </>
                                                            </div>
                                                        )}
                                                </div>
                                            </React.Fragment>
                                        ))}
                                </div>
                            </ScrollPanel>
                        </div>
                    </div>
                )}
            </Dialog>
            {/*<IncomingDetailLocDataDialog visible={locDataVisible} onHide={(e) => onLocDataHide}*/}
        </>
    )
}

export default IncomingDetailArrivalDialog
